import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import PhoneForwardedSharpIcon from '@material-ui/icons/PhoneForwardedSharp';
import ThumbDownAltSharpIcon from '@material-ui/icons/ThumbDownAltSharp';
import Controls from '../../controls/Controls';
import { baseUrl } from '../../../utils/constants';
import { useClaimsContext } from '../../../context/claims_context';
import { useClientContext } from '../../../context/client_context';

function DeclineClaim(props) {
  const { closePopup, claimRefId, clientRefId, documentRefId } = props;
  console.log('clamazo: ', claimRefId, 'clientRefId: ', clientRefId);
  const userRefId = sessionStorage.getItem('oldRefId');
  const { currentClient } = useClientContext();
  const [loading, setLoading] = useState(false);
  const [declineReasons, setDeclineReasons] = useState([
    {
      id: 59,
      key: 59,
      label: 'Active Loans',
      value: 'Active Loans',
      text: 'your application for credit was declined as you 1st need to settle your outstanding loans.'
    },
    {
      id: 33,
      key: 33,
      label: 'Arrears',
      value: 'Arrears',
      text: 'your application for credit has been declined due to arrears on your active loan/s with us. Please contact us to make payment arrangements on 000 000 0000.'
    }
  ]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  const DeclineSchema = Yup.object().shape({
    message: Yup.string()
      .min(2, 'Decline Reason is too Short!')
      .max(300, 'Decline Reason is too Long!')
      .required('Decline Reason is required'),
    reasonId: Yup.number().required('Please select a Decline Reason')
  });

  const initialValue = {
    claimRefId,
    message: '',
    reasonId: 33,
    acceptDeclinedReferralSelected: false
  };

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    validationSchema: DeclineSchema,
    onSubmit: (values) => {
      console.log('decline values ', values);
      closePopup();
    }
  });

  useEffect(() => {
    getDeclineReasonList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDeclineReasonList = async () => {
    setLoading(true);
    console.log('validation refid in decline', claimRefId, currentClient);
    await axios(
      `${baseUrl}/api/claims/GetSmsViewModel?cifNumber=${clientRefId}&isDecline=true&validationRefId=${claimRefId}`
    ).then(
      (result) => {
        setLoading(false);
        console.log('result from GetSmsViewModel', result);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Getting Decline Reasons!: ${result.replyMessage}`, 'error');
        } else {
          setDeclineReasons(result.data.declineReasonList);
          // notifyPopup('Decline Reasons Retrieved Successfully!', 'success');
        }
      },
      (error) => {
        notifyPopup(`Fatal Error Getting Decline Reasons!: ${error}`, 'error');
      }
    );
  };

  const declineValidationWithComment = async (data) => {
    setLoading(true);
    console.log('decline with comment', data);
    await axios
      .post(
        `${baseUrl}/api/claims/rejectClaim?claimId=${claimRefId}&rejectReason=${
          formik.values.message
        }&rejectedBy=${userRefId}&rejectLevel=${0}&sendSms=false`
      )
      .then(
        (result) => {
          setLoading(false);
          console.log('result from declineValidationWithComment', result);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Declining Claim Application!: ${result.replyMessage}`, 'error');
          } else {
            navigate('/');
          }
        },
        (error) => {
          notifyPopup(`Fatal Error in Declining Claim Application!: ${error}`, 'error');
        }
      );
  };

  const declineValidationWithSms = async (data) => {
    setLoading(true);
    console.log('decline with comment', data, formik.values.message);
    console.log('decline with currentClient.cellNumber', currentClient.cellNumber);
    await axios
      .post(
        `${baseUrl}/api/claims/rejectClaim?claimId=${claimRefId}&rejectReason=${
          formik.values.message
        }&rejectedBy=${userRefId}&rejectLevel=${0}&sendSms=true`
      )
      .then(
        (result) => {
          setLoading(false);
          console.log('result from declineValidationWithSms', result);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Declining Claim!: ${result.replyMessage}`, 'error');
          } else {
            navigate('/');
          }
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Fatal Error in Declining Claim Application!: ${error}`, 'error');
        }
      );
  };

  const rejectClaim = (data) => {
    // setDisabled(true);
    fetch(
      `${baseUrl}/api/claims/rejectClaim?claimId=${claimRefId}&rejectReason=${
        formik.values.message
      }&rejectedBy=${userRefId}&rejectLevel=${0}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          notifyPopup(`Dependant Saved Successfully!`, 'success');
          navigate('/dashboard', { replace: true });
        },
        (error) => {
          notifyPopup(`Error in Saving Client!: ${error}`, 'error');
        }
      );
  };

  const updateMessage = (e) => {
    const msg = declineReasons.find((x) => x.key === e);
    if (msg) formik.setFieldValue('message', msg.message);
    console.log('message 01', msg.message);
    console.log('message', e);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          onClick={handleLoadingClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            {/* <Controls.SelectJsonApi
              name="reasonId"
              label="Decline Reason"
              options={declineReasons}
            /> */}
            <FormControl fullWidth>
              <InputLabel id="reasonIdlabel">Decline Reason</InputLabel>
              <Select
                id="reasonId"
                value={formik.values.reasonId}
                name="reasonId"
                fullWidth
                size="small"
                variant="outlined"
                onChange={(e) => {
                  formik.setFieldValue('reasonId', e.target.value);
                  updateMessage(e.target.value);
                }}
              >
                {declineReasons.map((item) => (
                  <MenuItem key={item.id} value={item.key} message={item.message}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={8}>
            <Controls.Input name="message" multiline maxRows={5} label="Decline Notes" />
          </Grid>

          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={4} marginRight={1}>
              <Button
                type="button"
                variant="outlined"
                startIcon={<PhoneForwardedSharpIcon />}
                onClick={() => declineValidationWithSms(formik.values.reasonId)}
              >
                Decline (SMS)
              </Button>
            </Grid>
            <Grid item xs={12} sm={4} marginRight={1}>
              <Button
                type="submit"
                variant="outlined"
                color="error"
                startIcon={<ThumbDownAltSharpIcon />}
                onClick={() => declineValidationWithComment(formik.values.reasonId)}
              >
                Decline (Comment)
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default DeclineClaim;
